import * as React from 'react';

import type { LinkType } from '../../link';
import Link from '../Link';
import { styled } from '../themeContext';

import { ReactComponent as YoutubeIconSvg } from './socialLinks/youtube.svg';
import { ReactComponent as FacebookIconSvg } from './socialLinks/facebook.svg';
import { ReactComponent as TwitterIconSvg } from './socialLinks/twitter.svg';
import { ReactComponent as NaverCafeIconSvg } from './socialLinks/naver-cafe.svg';
import { ReactComponent as InstagramIconSvg } from './socialLinks/instagram.svg';
import { ReactComponent as LineIconSvg } from './socialLinks/line.svg';


type SocialEntry = {
  service: NonNullable<GatsbyTypes.Footer_socialLinksFragment['snsLinks'][number]>['service'],
  entry: {
    link: LinkType,
    label: string,
  },
};

type SocialLinksProps = {
  className?: string,
  socials: SocialEntry[],
};

const Container = styled.div({
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  width: '100%',
  height: '100%',
  margin: '0 auto',
});

const IconWrapper = styled.span((props) => ({
  'display': 'flex',
  'alignItems': 'center',
  'justifyContent': 'center',
  'margin': '0 0.16em',
  'width': '1em',
  'height': '1em',
  '> svg': {
    width: '100%',
    height: '100%',
  },
  [props.theme.media['sm']]: {
    margin: '0 0.32em 0.3em 0.32em',
  },
}));

const SocialLinks: React.FC<SocialLinksProps> = ({
  className,
  socials,
}) => {
  return (
    <Container className={className}>
      {socials.map(social => {
        const SocialIconSvg = iconMap[social.service];
        return SocialIconSvg ? (
          <Link
            key={`social-link-${social.service}`}
            link={social.entry.link}
          >
            <IconWrapper>
              <SocialIconSvg />
            </IconWrapper>
          </Link>
        ) : null;
      })}
    </Container>
  );
};

export default SocialLinks;

const iconMap: { [key in NonNullable<GatsbyTypes.Footer_socialLinksFragment['snsLinks'][number]>['service']]: React.FC | null } = {
  YOUTUBE: YoutubeIconSvg,
  FACEBOOK: FacebookIconSvg,
  TWITTER: TwitterIconSvg,
  NAVER_CAFE: NaverCafeIconSvg,
  INSTAGRAM: InstagramIconSvg,
  LINE: LineIconSvg,
  FORUM: null,
  DISCORD: null,
  REDDIT: null,
  WEIBO: null,
  BILIBILI: null,
};
